import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../api/client';

export interface BankRecLine {
  journalEntryLineId: string;
  entryNumber: string;
  entryDate: string;
  description: string | null;
  debit: number;
  credit: number;
  clearanceDate: string | null;
}

export interface BankRecDto {
  accountId: string;
  accountCode: string;
  accountNameAr: string;
  accountNameEn: string | null;
  ledgerBalance: number;
  clearedBalance: number;
  lines: BankRecLine[];
}

export function useBankReconciliation(accountId: string | null, asOf: string) {
  return useQuery({
    queryKey: ['bank-rec', accountId, asOf] as const,
    enabled: !!accountId,
    queryFn: async () =>
      (await apiClient.get<BankRecDto>('/api/accounting/bank-reconciliation', {
        params: { accountId, asOf },
      })).data,
  });
}

export function useSetClearance() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (req: { accountId: string; lineIds: string[]; clearanceDate: string | null }) => {
      await apiClient.post('/api/accounting/bank-reconciliation/clear', req);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['bank-rec'] }),
  });
}
